import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { catchError, switchMap, throwError } from "rxjs";
import { MsalService } from "@azure/msal-angular";

import { AuthService, MessageService, RegistrationService } from "@services";
import { AppBaseComponent } from "@utils";
import {environment} from "../../../../../environments/environment";

/**
 * Componente para el header de la aplicación
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends AppBaseComponent implements OnInit {

  /**
   * Logo de GOV.CO
   */
  public readonly imagelogoRoute: string = '../../../../../assets/images/logo.svg';

  /**
   * Centinela para controlar el boton de inicio de sesión
   */
  public loginDisplay: boolean = false;

  /**
   * Nombre del usuario logueado
   */
  public userName: string = '';

  /**
   * Rol del usuario logueado
   */
  public rolName: string = '';

  /**
   * Id del usuario logueado
   */
  private idUser: string = "";


  constructor(private msalAuthService: MsalService,
    private authService: AuthService,
    private popupAlert: MessageService,
    public registrationService: RegistrationService,
    private router: Router) {
    super();
    this.cargarventanilla = this.cargarventanilla.bind(this);

  }


  /**
   * Hook del componente
   */
  ngOnInit(): void {
    this.setLoginDisplay();
    const metodoExterno = this.cargarventanilla;
    window.addEventListener('message', function (event) {
      console.log('aca entro evento login')
      // Verifica el origen del mensaje


      if (event.origin==environment.VUDTS_URL_LOCAL || event.origin == environment.VUDTS_URL) {
        console.log(event.data)
        if(event.data.oid==undefined)
        {
          console.log('origen no admitido');
        }
        else
        {
          const datos = event.data;
          console.log(datos)

          localStorage.setItem('datosventanilla', JSON.stringify(datos));
          /**
           * Obtiene el idUser en la url para efectos de inicio de sesion desde la ventanilla
           */
          metodoExterno(datos.oid);
          const respuesta = datos.oid;

          // @ts-ignore
          event.source.postMessage(respuesta, event.origin);
        }


      }
      else {
        console.log('origen no admitido');
      }
    });
  }

  /**
   * Valida si ya existe un usuario desde ventanilla o si debe iniciar el logueo con el flujo de MSAL
   */
  public login(): void {

    if (localStorage.getItem("currentUser") == null) {
      if (this.idUser == "") {
        this.popUpAuthenticationB2C();
        console.log("valor sin id", this.idUser)
      } else {
        console.log("estoy en ventanilla")

        let user=JSON.parse( localStorage.getItem('datosventanilla')).flujo;
        let oid=JSON.parse( localStorage.getItem('datosventanilla')).oid;
        this.addUserToLocalStorageLogin(user, oid);

        /*
        this.authService.getInfoToken(this.idUser)
        */

        console.log("valor con id", this.idUser)
      }
    }
  }

  /**
   * Cierra la sesión mediante el popUp de MSAL
   */
  public logout(): void {
    this.msalAuthService.logoutPopup({
      mainWindowRedirectUri: "/"
    }).subscribe(resp => {
      this.popupAlert.infoAlert("¡Sesión cerrada exitosamente!", 4000);
      localStorage.clear();
      this.authService.setCurrentUser(null);
    });
  }

  /**
   * Cambia el texto del usuario logueado
   */
  private setLoginDisplay() {
    this.loginDisplay = this.msalAuthService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay || localStorage.getItem('datosventanilla')!=null) {
      this.loginDisplay=true;
      let user = this.authService.getCurrentUser();


      if (user!=null)
      {
        if (user.roles != null && user.roles.length != 0) {
          this.rolName = user.roles[0].value;
        }
      }
      else {
        const res = this.msalAuthService.instance.getAllAccounts()[0];
        console.log(res);
        this.authService.setCurrentUser(res).subscribe(resp => user = resp);
      }


      this.userName = `${user.given_name} ${user.family_name ?? ""}`;
    }

  }

  /**
   * Lanza el popUp de MSAL para iniciar sesión
   */
  private popUpAuthenticationB2C() {
    this.msalAuthService.loginPopup().subscribe({
      next: res => {
        this.popupAlert.infoAlert("Cargando inicio de sesión...", 5000);
        let user: any = { ...res }

        this.addUserToLocalStorageLogin(user, res.idTokenClaims["oid"]);
      },
      error: error => {
        this.popupAlert.errorAlert("Ha ocurrido un error al iniciar sesión.", 4000);
      }
    });
  }

  /**
   * Flujo del inicio de sesión mediante MSAL
   * Valida si la persona ya se encuentra registrada, si tiene codigo de ventanilla y si ya aceptó politicas de seguridad
   * @param user User enviado del MSAL
   * @param idTokenClaims IdToken enviado del MSAL
   */
  private addUserToLocalStorageLogin(user: any, idTokenClaims: any) {

    let tieneCodigoVentanilla: boolean = false;
    let aceptoPoliticaDatos: boolean = false;
    let roles: any;

    try {
      const userOidToken = idTokenClaims;

      this.registrationService.getCodeVentanillaByIdUser(userOidToken.toUpperCase()).pipe(
        switchMap(resp1 => {

          user.idTokenClaims["idCodigoVentanilla"] = resp1.data;
          tieneCodigoVentanilla = true;
          return this.registrationService.getPoliticaSeguridad(userOidToken);
        }),
        switchMap(resp2 => {
          aceptoPoliticaDatos = resp2.data != null;
          if (!aceptoPoliticaDatos) {
            throw new Error("politica");
          }
          return this.registrationService.getRoleByIdUser(userOidToken);
        }),
        switchMap(resp3 => {

          roles = resp3.data;
          if (roles.length == 0) {
            this.popupAlert.errorAlert("Ha ocurrido un error al iniciar sesión.", 4000);
          }
          return this.registrationService.getInfoUserByIdCodeVentanilla(user.idTokenClaims["idCodigoVentanilla"])
        }),
        catchError(error => {
          console.log('Ocurrió un error: estoy en catchError', error);
          return throwError(() => new Error(error.message));
        })
      ).subscribe({
        next: resp4 => {
          let infoUser = resp4.data;
          if(infoUser!=null)
          {
            let personTypeId: number = infoUser.numeroIdentificacionRL != null ? 2 : 1;

            let datosPersonales = {
              "personTypeId": personTypeId,
              "numeroIdentificacion": infoUser.numeroIdentificacion,
              "fullName": infoUser.fullName,
              "tipoIdentificacion": infoUser.tipoIdentificacion,
              "primerNombre": infoUser.primerNombre,
              "segundoNombre": infoUser.segundoNombre,
              "primerApellido": infoUser.primerApellido,
              "segundoApellido": infoUser.segundoApellido,
              "email": infoUser.email,
              "telefonoFijo": infoUser.telefonoFijo,
              "telefonoCelular": infoUser.telefonoCelular,
              "tipoIdentificacionRL": infoUser.tipoIdentificacionRL,
              "numeroIdentificacionRL": infoUser.numeroIdentificacionRL,
              "razonSocial": infoUser.razonSocial,
              "direResi": "DireccionCasa",
              "departamento": "DepartamentoCasa",
              "municipio": "MunicipioCasa",
            }


            user.idTokenClaims["datosPersonales"] = datosPersonales;
            user.idTokenClaims["roles"] = roles;
            user.idTokenClaims["tieneCodigoVentanilla"] = tieneCodigoVentanilla;
            user.idTokenClaims["aceptoPoliticaSeguridad"] = aceptoPoliticaDatos;

            this.authService.setCurrentUser(user, 1);
            this.setLoginDisplay();

            this.popupAlert.successAlert('Bienvenid@ a Secretaría de Salud Bogotá - Tramite Licencia SST', 4000);
            location.reload();
          }
          else {
            console.log("no esta registrado")
            this.popupAlert.errorAlert("Ha ocurrido un error al iniciar sesión.", 4000);
            user.idTokenClaims["tieneCodigoVentanilla"] = tieneCodigoVentanilla;
            user.idTokenClaims["aceptoPoliticaSeguridad"] = aceptoPoliticaDatos;
            user.idTokenClaims["roles"] = [];
            super.popUpRegistroNaturalJuridica(this.router);


            this.authService.setCurrentUser(user, 1);
            this.setLoginDisplay();
          }


        },
        error: err => {
          console.log("estoy en subcribe error", err.message)
          this.popupAlert.errorAlert("Ha ocurrido un error al iniciar sesión.", 4000);
          user.idTokenClaims["tieneCodigoVentanilla"] = tieneCodigoVentanilla;
          user.idTokenClaims["aceptoPoliticaSeguridad"] = aceptoPoliticaDatos;
          user.idTokenClaims["roles"] = [];

          if (err.message == "politica") {
            super.popUpAceptarPoliticaDatos(this.router);
          } else {
            super.popUpRegistroNaturalJuridica(this.router);
          }

          this.authService.setCurrentUser(user, 1);
          this.setLoginDisplay();
        }
      }
      );
    } catch (e) {
      console.log('error')
      this.popupAlert.errorAlert("Ha ocurrido un error al iniciar sesión.", 4000);
    }
  }
  cargarventanilla(id: any) {
    console.log("estoy en ventanilla")

    let user=JSON.parse( localStorage.getItem('datosventanilla')).flujo;
    let oid=JSON.parse( localStorage.getItem('datosventanilla')).oid;
    this.addUserToLocalStorageLogin(user, oid);

    /*
    this.authService.getInfoToken(this.idUser)
    */

    console.log("valor con id", this.idUser)
  }

}
